"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.audioVideoDidStartConnectingHandler = audioVideoDidStartConnectingHandler;
var _StudioLogger = require("@studio/logger/StudioLogger");
var _logger = require("../../../constants/logger");
var logger = new _StudioLogger.StudioLogger(_logger.loggerName);
function audioVideoDidStartConnectingHandler(reconnectingStatus, meetingResponse, attendeeResponse) {
  // Log attendee connection status
  var meetingId = meetingResponse.Meeting.MeetingId;
  var attendeeId = attendeeResponse.Attendee.AttendeeId;
  var logPayload = {
    chimeEventName: 'audioVideoDidStartConnecting',
    'studio.meeting.id': meetingId,
    title: "Audio-Video is ".concat(reconnectingStatus ? 'reconnecting' : 'connecting', " for attendee ").concat(attendeeId, " in meeting ").concat(meetingId)
  };
  logger.info(logPayload.title, logPayload);
}